<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label mb-2 block font-bold text-gray-700">{{ label }}:</label>
    <div class="ckeditor-wrapper">
        <ckeditor :editor="editor" v-model="proxyValue" :config="editorConfig"></ckeditor>
    </div>
    <div v-if="error" class="form-error text-red-700 mt-2">{{ error }}</div>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Ckeditor } from '@ckeditor/ckeditor5-vue';

export default {
  components: {
    ckeditor: Ckeditor
  },
  props: {
    modelValue: String,
    label: String,
    error: String,
  },
  emits: ['update:modelValue'],
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        // The configuration of the editor.
        toolbar: [ 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo' ]
      }
    };
  },
  computed: {
    proxyValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>

<style>
.ck-editor__editable {
    min-height: 200px;
}
</style>
